export enum ButterCmsComponent {
  // Not dynamic (yet)
  ExpandComponent = "expand_component",

  // Root
  PageHeader = "page_header",
  Content = "content",

  // Partials
  ContentText = "content_text",
  ContentTitle = "content_title",
  MediaUrl = "media_url",
}
